export default __webpack_public_path__ + "static/media/cnb.30c5e083.webp";